export default {
  label: {
    today: 'hôm nay',
    yesterday: 'hôm qua',
    toMonth: 'tháng này',
    todayDetails: 'chi tiết hôm nay',
    yesterdayDetails: 'chi tiết hôm qua',
    toMonthDetails: 'chi tiết tháng này',
    focusinfo: 'thông tin chung',
    amountOfFail: 'tổng tiền thất bại',
    amountOfProfit: 'lãi',
    amountOfSuccess: 'tổng tiền thành công',
    amountOfTotal: 'tổng tiền giao dịch',
    paymentNumberOfSuccess: 'Số đơn nhập khoản thành công',
    payoutNumberOfSuccess: 'Số đơn xuất khoản thành công',
    paymentNumberOfFail: 'Số đơn nhập khoản thất bại',
    payOutNumberOfFail: 'Số đơn xuất khoản thất bại',
    paymentNumberOfTotal: 'Tổng số đơn nhập khoản',
    payoutNumberOfTotal: 'Tổng số đơn xuất khoản',
    paymentAmountOfSuccess: 'Tổng số tiền nhập khoản thành công',
    payoutAmountOfSuccess: 'Tổng số tiền xuất khoản thành công',
    paymentAmountOfFail: 'Tổng số tiền nhập khoản thất bại',
    payoutAmountOfFail: 'Tổng số tiền xuất khoản thất bại',
    paymentAmountOfTotal: 'Tổng số tiền nhập khoản',
    payoutAmountOfTotal: 'Tổng số tiền xuất khoản',
    channel: 'kênh thanh toán',
    dateByDay: 'ngày',
    dateByMonth: 'tháng',
    dateType: 'thời gian',
    id: 'ID',
    numberOfFail: 'tổng đơn thất bại',
    numberOfSuccess: 'tổng đơn thành công',
    numberOfTotal: 'tổng đơn',
    owner: '拥有者',
    updateTime: 'thời gian cập nhật',
    userType: 'loại tài khoản',
    successRate: 'Tỉ lệ thành công',
    MerchantBalance:'Số dư của người bán',
    totalWalletBalance:'Tổng số dư ví',
    usdtWalletBalance:'Số dư USDT',
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/welcome.js